module.exports = __webpack_public_path__ + "static/media/IGS-teal-upload.94dc8e86.png";